<template>
    <div>
        <div class="accounts-title">{{ $t('permission_configuration_management.account.account') }}</div>
        <div class="accounts-top">
            <account-search></account-search>
        </div>
        <table-accounts></table-accounts>
    </div>
</template>

<script>
    import AccountSearch from '../account/AccountSearch'
    import TableAccounts from '../account/TableAccounts'

    export default {
        name: 'Accounts',
        components: {
            AccountSearch,
            TableAccounts
        }
    }
</script>

<style scoped>
    .accounts-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .accounts-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account/Accounts.vue